<!-- Component for select tag       -->

<script>
// import eventbus from '@src/state/EventBus'
// import axios from 'axios'
import { appConfig } from '@src/app.config'

import { services } from '@utils/common-services'
export default {
  // Disable automatic attribute inheritance, so that $attrs are
  // passed to the <input>, even if it's not the root element.
  // https://vuejs.org/v2/guide/components-props.html#Disabling-Attribute-Inheritance
  inheritAttrs: false,
  // Change the v-model event name to `update` to avoid changing
  // the behavior of the native `input` event.
  // https://vuejs.org/v2/guide/components-custom-events.html#Customizing-Component-v-model
  model: {
    event: 'input',
  },
  props: {
    value: {
      type: String,
      default() {
        return '-Select-'
      },
    },
    label: {
      type: String,
      default() {
        return ''
      },
    },
    validation: {
      type: Object,
      default() {
        return {}
      },
    },
    valid: {
      type: Boolean,
      default() {
        return false
      },
    },
    options: {
      type: Object,
      required: true,
    },
    name: {
      type: String,
      default() {
        return ''
      },
    },
    // eslint-disable-next-line vue/require-default-prop

    form: {
      type: String,
      default() {
        return ''
      },
    },
  },
  data() {
    return {
      selected: null,
      option: [],
      optGroup: [],
    }
  },

  watch: {
    value(newVal, oldVal) {
      if (newVal !== oldVal) {
        var x = -1
        for (var i = 0; i < this.optGroup.length; i++) {
          x = this.optGroup[i]['ethnicGroup'].findIndex(
            (y) => y.code === this.value
          )
          if (x !== -1) break
        }

        if (x !== -1) {
          this.selected = this.value
          //    this.callDependency(this.value)
        }
      }
    },
  },
  beforeDestroy() {
    var doc = this.$refs[this.name + 'ethinic']
    if (doc !== undefined) doc.innerHTML = ''
  },
  created() {
    const apiUrl = appConfig.apiUrl
    this.$store
      .dispatch('jv/get', [
        this.options.type,
        {
          url: apiUrl + this.options.to,
          headers: services.getHeaderAuthorization(),
        },
      ])

      .then((data) => {
        this.option.length = 0

        var check = {}

        check = this.$store.getters['jv/get'](this.options.type)
        var id = Object.keys(check)
        //  this.option.push({ code: null, label: '-Select-' })

        for (var i = 0; i < id.length; i++) {
          var ethnicid = Object.keys(check[id[i]]['ethnicGroup'])
          var option = []
          for (var j = 0; j < ethnicid.length; j++)
            option.push({
              code: check[id[i]]['ethnicGroup'][ethnicid[j]]['name'],
              label: check[id[i]]['ethnicGroup'][ethnicid[j]]['name'],
            })

          this.optGroup.push({
            ethnicGroup: option,
            label: check[id[i]]['name'],
          })
          //     console.log(this.optGroup)
        }
        //    console.log(this.optGroup)

        this.checkData()
      })
      .catch((error) => {
        if (error) {
          this.option.length = 0
          this.option[0] = { code: null, label: '-Select-' }
        }
      })
  },
  mounted() {
    this.checkData()
  },

  methods: {
    checkData() {
      var x = -1
      for (var i = 0; i < this.optGroup.length; i++) {
        x = this.optGroup[i]['ethnicGroup'].findIndex(
          (y) => y.code === this.value
        )

        if (x !== -1) break
      }

      if (x !== -1) {
        this.selected = this.value
        //   this.callDependency(this.value)
      }
    },
    /*  callDependency(data) {
      if (
        this.options.dependency !== undefined &&
        this.options.dependency !== null
      ) {
        if (
          this.options.dependency.find((element) => element === data) !==
          undefined
        )
          this.$root.$emit('dependency', { name: this.name, value: data })
        else this.$root.$emit('dependency', { name: this.name, value: data })
      }
    }, */
    sendData(event) {
      // eventbus.$emit('testEvent', 'test')

      //    eventbus.$emit('testEvent', 'validate_all')
      if (event.target.value !== null) {
        this.$refs[this.name].reset()
        this.$emit('update', event.target.value)
        this.selected = event.target.value
        //   this.callDependency(event.target.value)
      }
    },
  },
}
// v-validate.disable="'required'"
</script>

<template
  ><div :ref="name + 'ethinic'">
    <div :class="$style.formGroup" class="formGroup mt20 mt10-sm">
      <div class="formFieldWrap">
        <label
          :for="name"
          :class="$style.fieldTitle"
          class="w40 w100-sm FL pr15 pr0-sm"
          >{{ label }}</label
        >
        <div class="form-field w60 w100-sm FL">
          <div :class="$style.options">
            <ValidationProvider
              :ref="name"
              v-slot="{ errors }"
              mode="passive"
              :vid="name"
              :name="name"
              :rules="validation"
            >
              <select
                :id="name"
                :value="selected"
                :name="name"
                @change="sendData"
              >
                <option :value="null">-Select-</option>
                <optgroup
                  v-for="(opt, index) in optGroup"
                  :key="index"
                  :label="opt.label"
                >
                  <option
                    v-for="(opt1, index1) in opt.ethnicGroup"
                    :key="index1"
                    :value="opt1.code"
                    >{{ opt1.label }}</option
                  >
                </optgroup>
              </select>

              <span v-show="errors[0]" :class="$style.error">{{
                errors[0]
              }}</span>
            </ValidationProvider>
          </div>
        </div>
        <div class="clear"></div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" module>
@import '@design';
.formGroup {
  max-width: 500px;
}
</style>
